export default "__VITE_ASSET__1aa05412__"